import React from 'react';
import { orderBy } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHistory, faPlay } from '@fortawesome/pro-regular-svg-icons';
import AlertLevels from '../../../../components/ns/AlertLevels';
import style from './index.scss';
import { Popover, Space } from 'antd';
import {
  convertISOToDateFormat,
  convertISOToDateTimeFormat
} from '../../../../util/timezone';

const InProductionIcon = ({ color }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill={color}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.34456 1.79565C5.32334 1.80657 5.30732 1.82548 5.30004 1.84821C5.29275 1.87094 5.29479 1.89563 5.30572 1.91686L5.80931 2.89542C5.83205 2.93962 5.88632 2.95701 5.93052 2.93427C6.90585 2.43234 7.97225 2.18413 9.03735 2.18936C9.25309 2.19042 9.46878 2.20188 9.68365 2.22373C9.98935 2.25483 10.2934 2.30697 10.5936 2.38014C10.8581 2.44463 11.1196 2.52546 11.3766 2.62263C11.4525 2.65134 11.5281 2.68148 11.6032 2.71304L11.1078 3.30949C11.0883 3.33295 11.082 3.3647 11.0911 3.39382C11.1002 3.42294 11.1234 3.44547 11.1528 3.45367L14.6528 4.4311C14.687 4.44064 14.7236 4.42921 14.7462 4.40191C14.7689 4.37461 14.7734 4.33654 14.7578 4.3047L13.1543 1.04395C13.1408 1.01657 13.1144 0.997877 13.0841 0.994288C13.0538 0.990698 13.0238 1.0027 13.0043 1.02618L12.4507 1.69301C12.3772 1.65786 12.3033 1.62389 12.229 1.5911C12.1718 1.56585 12.1143 1.5413 12.0567 1.51745C11.9504 1.47346 11.8433 1.43186 11.7356 1.39264C11.102 1.16191 10.4459 1.01366 9.78357 0.948426C9.67957 0.938183 9.57542 0.929986 9.47118 0.923837C9.32895 0.915448 9.18654 0.910872 9.04412 0.910113C8.81301 0.908883 8.58186 0.917659 8.35135 0.936446C7.31625 1.02081 6.29397 1.30707 5.34456 1.79565Z"
        fill={color}
        stroke={color}
        strokeWidth="0.18"
        strokeLinejoin="round"
      />
      <path
        d="M16.205 5.34358C16.1941 5.32236 16.1752 5.30634 16.1525 5.29906C16.1297 5.29177 16.105 5.29382 16.0838 5.30474L15.1052 5.80833C15.061 5.83108 15.0437 5.88534 15.0664 5.92954C15.9798 7.7044 16.053 9.78088 15.2876 11.6022L14.6912 11.1068C14.6677 11.0873 14.636 11.0811 14.6068 11.0902C14.5777 11.0992 14.5552 11.1225 14.547 11.1519L13.5696 14.6518C13.56 14.686 13.5715 14.7226 13.5988 14.7453C13.626 14.7679 13.6641 14.7724 13.696 14.7568L16.9567 13.1533C16.9841 13.1398 17.0028 13.1134 17.0064 13.0831C17.01 13.0528 16.998 13.0228 16.9745 13.0033L16.3076 12.4497C17.3829 10.2011 17.3511 7.57059 16.205 5.34358Z"
        fill={color}
        stroke={color}
        strokeWidth="0.18"
        strokeLinejoin="round"
      />
      <path
        d="M3.34843 13.5697C3.31425 13.5601 3.27765 13.5716 3.25498 13.5989C3.23231 13.6262 3.2278 13.6642 3.24346 13.6961L4.84694 16.9568C4.8604 16.9842 4.88681 17.0029 4.91711 17.0065C4.94741 17.0101 4.97746 16.9981 4.99695 16.9746L5.55053 16.3078C7.79913 17.3831 10.4296 17.3512 12.6567 16.2051C12.6779 16.1942 12.6939 16.1753 12.7012 16.1526C12.7085 16.1298 12.7064 16.1052 12.6955 16.0839L12.1919 15.1054C12.1692 15.0612 12.1149 15.0438 12.0707 15.0665C10.2958 15.9799 8.21936 16.0531 6.39802 15.2877L6.89341 14.6913C6.9129 14.6678 6.91918 14.6361 6.91008 14.607C6.90099 14.5778 6.87777 14.5553 6.84838 14.5471L3.34843 13.5697Z"
        fill={color}
        stroke={color}
        strokeWidth="0.18"
        strokeLinejoin="round"
      />
      <mask
        id="path-4-outside-1_12711_16918"
        maskUnits="userSpaceOnUse"
        x="0"
        y="2.32452"
        width="5"
        height="11"
        fill="black">
        <rect fill="white" y="2.32452" width="5" height="11" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.87511 12.6158L2.85368 12.1122C2.85382 12.1125 2.85353 12.1119 2.85368 12.1122C2.24234 10.9238 2.00217 9.60121 2.13363 8.30876C2.16514 7.99896 2.21798 7.69084 2.29214 7.38665C2.35749 7.11857 2.43941 6.85354 2.53788 6.5931C2.58119 6.47854 2.6277 6.36487 2.67742 6.25222L3.36642 6.82448L4.34385 3.32452L1.0831 4.928L1.80415 5.52659C1.75845 5.62002 1.71469 5.71414 1.67288 5.80889C1.64792 5.86547 1.62364 5.92227 1.60007 5.97929C1.55659 6.08441 1.51547 6.19026 1.47672 6.29675C1.2488 6.92298 1.10254 7.57133 1.03808 8.22598C1.0279 8.32941 1.01976 8.43301 1.01366 8.5367C0.991993 8.90498 0.996099 9.27446 1.026 9.64235C1.10919 10.6659 1.39205 11.6771 1.87511 12.6158Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.87511 12.6158L2.85368 12.1122C2.85382 12.1125 2.85353 12.1119 2.85368 12.1122C2.24234 10.9238 2.00217 9.60121 2.13363 8.30876C2.16514 7.99896 2.21798 7.69084 2.29214 7.38665C2.35749 7.11857 2.43941 6.85354 2.53788 6.5931C2.58119 6.47854 2.6277 6.36487 2.67742 6.25222L3.36642 6.82448L4.34385 3.32452L1.0831 4.928L1.80415 5.52659C1.75845 5.62002 1.71469 5.71414 1.67288 5.80889C1.64792 5.86547 1.62364 5.92227 1.60007 5.97929C1.55659 6.08441 1.51547 6.19026 1.47672 6.29675C1.2488 6.92298 1.10254 7.57133 1.03808 8.22598C1.0279 8.32941 1.01976 8.43301 1.01366 8.5367C0.991993 8.90498 0.996099 9.27446 1.026 9.64235C1.10919 10.6659 1.39205 11.6771 1.87511 12.6158Z"
        fill={color}
      />
      <path
        d="M1.87511 12.6158L1.71506 12.6981C1.7369 12.7406 1.77471 12.7726 1.82018 12.7872C1.86564 12.8018 1.91502 12.7977 1.95747 12.7758L1.87511 12.6158ZM2.13363 8.30876L1.95455 8.29055L2.13363 8.30876ZM2.29214 7.38665L2.46702 7.42928V7.42928L2.29214 7.38665ZM2.53788 6.5931L2.70625 6.65675L2.53788 6.5931ZM2.67742 6.25222L2.79243 6.11375C2.749 6.07768 2.69116 6.06407 2.6362 6.077C2.58124 6.08993 2.53554 6.12789 2.51274 6.17954L2.67742 6.25222ZM3.36642 6.82448L3.25142 6.96295C3.29835 7.00193 3.36184 7.01449 3.42008 6.9963C3.47832 6.97811 3.52338 6.93166 3.53979 6.8729L3.36642 6.82448ZM4.34385 3.32452L4.51721 3.37294C4.5363 3.30458 4.51344 3.23139 4.45885 3.18605C4.40425 3.14071 4.3281 3.13168 4.26442 3.163L4.34385 3.32452ZM1.0831 4.928L1.00367 4.76648C0.94891 4.7934 0.911524 4.84623 0.904346 4.90683C0.897168 4.96742 0.921175 5.02753 0.968122 5.0665L1.0831 4.928ZM1.80415 5.52659L1.96584 5.60568C2.00234 5.53106 1.98303 5.44115 1.91912 5.38809L1.80415 5.52659ZM1.67288 5.80889L1.5082 5.73622H1.5082L1.67288 5.80889ZM1.60007 5.97929L1.7664 6.04808L1.60007 5.97929ZM1.47672 6.29675L1.30757 6.23519V6.23519L1.47672 6.29675ZM1.03808 8.22598L1.21722 8.24362H1.21722L1.03808 8.22598ZM1.01366 8.5367L0.833968 8.52613L1.01366 8.5367ZM1.026 9.64235L1.20541 9.62777L1.026 9.64235ZM1.95747 12.7758L2.93604 12.2722L2.77131 11.9521L1.79274 12.4557L1.95747 12.7758ZM3.0137 12.0298C3.01368 12.0297 3.01366 12.0297 3.01364 12.0297C3.01363 12.0296 3.01363 12.0296 3.01362 12.0296C3.01361 12.0296 3.01358 12.0295 3.01354 12.0295C3.01353 12.0294 3.01351 12.0294 3.01348 12.0293C3.01346 12.0293 3.01339 12.0292 3.0133 12.029C3.01327 12.0289 3.01313 12.0287 3.01296 12.0283C3.01285 12.0281 3.01256 12.0276 3.01236 12.0272C3.01189 12.0264 3.00858 12.0205 3.00559 12.0156C2.76916 11.9532 2.69013 12.1874 2.69169 12.1907C2.69205 12.1914 2.69258 12.1925 2.69274 12.1928C2.69298 12.1933 2.69317 12.1937 2.69319 12.1937C2.6933 12.1939 2.69339 12.1941 2.6934 12.1941C2.69343 12.1942 2.69346 12.1942 2.69347 12.1942C2.69349 12.1943 2.69351 12.1943 2.69352 12.1944C2.69355 12.1944 2.69358 12.1945 2.69358 12.1945C2.69359 12.1945 2.69359 12.1945 2.6936 12.1945C2.69361 12.1945 2.69363 12.1945 2.69364 12.1946C2.69365 12.1946 2.69366 12.1946 2.69367 12.1946C2.69368 12.1947 2.69369 12.1947 2.6937 12.1947C2.6937 12.1947 2.69372 12.1947 2.69375 12.1948C2.69376 12.1948 2.69378 12.1948 2.6938 12.1949C2.69382 12.1949 2.69384 12.195 2.69387 12.195C2.69389 12.1951 2.69397 12.1952 2.69408 12.1954C2.69411 12.1955 2.6943 12.1958 2.69454 12.1963C2.6947 12.1966 2.69525 12.1976 2.69563 12.1983C2.69725 12.2012 2.93294 12.2739 3.02115 12.0462C3.01866 12.0402 3.0155 12.0334 3.01505 12.0324C3.01486 12.0321 3.01457 12.0315 3.01447 12.0313C3.0143 12.0309 3.01416 12.0307 3.01413 12.0306C3.01404 12.0304 3.01397 12.0303 3.01395 12.0303C3.01392 12.0302 3.0139 12.0302 3.01389 12.0301C3.01385 12.0301 3.01382 12.03 3.01381 12.03C3.0138 12.03 3.0138 12.03 3.01379 12.0299C3.01377 12.0299 3.01375 12.0299 3.01373 12.0298L2.69362 12.1945C2.69364 12.1946 2.69364 12.1946 2.69363 12.1946C2.69363 12.1946 2.69363 12.1946 2.69362 12.1945C2.69362 12.1945 2.69359 12.1945 2.69355 12.1944C2.69353 12.1944 2.69351 12.1943 2.69348 12.1943C2.69347 12.1942 2.6934 12.1941 2.69331 12.1939C2.69327 12.1939 2.69314 12.1936 2.69297 12.1933C2.69287 12.1931 2.69258 12.1925 2.69239 12.1921C2.69193 12.1912 2.68878 12.1843 2.68629 12.1783C2.7745 11.9506 3.01019 12.0233 3.01181 12.0262C3.01219 12.0269 3.01273 12.0279 3.0129 12.0282C3.01314 12.0287 3.01333 12.0291 3.01335 12.0291C3.01346 12.0293 3.01355 12.0295 3.01356 12.0295C3.01359 12.0296 3.01362 12.0296 3.01363 12.0296C3.01366 12.0297 3.01368 12.0297 3.01368 12.0297C3.01373 12.0298 3.01375 12.0299 3.01372 12.0298C3.01368 12.0297 3.0137 12.0298 3.01375 12.0299C3.01375 12.0299 3.01377 12.0299 3.0138 12.03C3.01381 12.03 3.01384 12.03 3.01387 12.0301C3.01388 12.0301 3.01397 12.0303 3.01407 12.0305C3.0141 12.0305 3.01429 12.0309 3.01452 12.0314C3.01469 12.0317 3.01522 12.0328 3.01558 12.0335C3.01713 12.0368 2.93811 12.2711 2.70168 12.2086C2.69868 12.2037 2.69537 12.1979 2.6949 12.197C2.69471 12.1966 2.69441 12.1961 2.69431 12.1959C2.69414 12.1955 2.694 12.1953 2.69397 12.1952C2.69388 12.195 2.6938 12.1949 2.69379 12.1949C2.69376 12.1948 2.69374 12.1948 2.69373 12.1947C2.69369 12.1947 2.69366 12.1946 2.69366 12.1946C2.69365 12.1946 2.69364 12.1946 2.69364 12.1946C2.69363 12.1946 2.69364 12.1946 2.69366 12.1946L3.0137 12.0298ZM3.01374 12.0298C2.41853 10.8728 2.18473 9.5852 2.31271 8.32698L1.95455 8.29055C1.81962 9.61722 2.06615 10.9748 2.69361 12.1945L3.01374 12.0298ZM2.31271 8.32698C2.34338 8.02537 2.39482 7.72542 2.46702 7.42928L2.11726 7.34402C2.04114 7.65627 1.9869 7.97255 1.95455 8.29055L2.31271 8.32698ZM2.46702 7.42928C2.53064 7.16831 2.61038 6.9103 2.70625 6.65675L2.36951 6.52944C2.26843 6.79678 2.18435 7.06883 2.11726 7.34402L2.46702 7.42928ZM2.70625 6.65675C2.74841 6.54523 2.79369 6.43457 2.8421 6.32489L2.51274 6.17954C2.46171 6.29517 2.41397 6.41185 2.36951 6.52944L2.70625 6.65675ZM2.56241 6.39069L3.25142 6.96295L3.48143 6.68601L2.79243 6.11375L2.56241 6.39069ZM0.968122 5.0665L1.68917 5.66509L1.91912 5.38809L1.19807 4.78951L0.968122 5.0665ZM1.64245 5.4475C1.59571 5.54306 1.55096 5.63932 1.5082 5.73622L1.83756 5.88156C1.87842 5.78897 1.92118 5.69699 1.96584 5.60568L1.64245 5.4475ZM1.5082 5.73622C1.48267 5.79409 1.45784 5.85218 1.43373 5.9105L1.7664 6.04808C1.78944 5.99236 1.81316 5.93685 1.83756 5.88156L1.5082 5.73622ZM1.43373 5.9105C1.38926 6.01802 1.34721 6.12628 1.30757 6.23519L1.64586 6.35831C1.68373 6.25425 1.72391 6.15081 1.7664 6.04808L1.43373 5.9105ZM1.30757 6.23519C1.07446 6.87569 0.924872 7.5388 0.858949 8.20834L1.21722 8.24362C1.28021 7.60386 1.42314 6.97027 1.64586 6.35831L1.30757 6.23519ZM0.858949 8.20834C0.848534 8.31413 0.840206 8.42008 0.833968 8.52613L1.19335 8.54727C1.19931 8.44594 1.20726 8.3447 1.21722 8.24362L0.858949 8.20834ZM0.833968 8.52613C0.811811 8.90279 0.81601 9.28067 0.846591 9.65693L1.20541 9.62777C1.17619 9.26825 1.17218 8.90718 1.19335 8.54727L0.833968 8.52613ZM0.846591 9.65693C0.931674 10.7038 1.22098 11.7381 1.71506 12.6981L2.03516 12.5334C1.56311 11.6161 1.2867 10.628 1.20541 9.62777L0.846591 9.65693ZM3.53979 6.8729L4.51721 3.37294L4.17048 3.27611L3.19306 6.77607L3.53979 6.8729ZM4.26442 3.163L1.00367 4.76648L1.16253 5.08953L4.42328 3.48605L4.26442 3.163Z"
        fill={color}
        mask="url(#path-4-outside-1_12711_16918)"
      />
    </svg>
  );
};

const getColumnRender = (column, record, apiActions, hanldeDrawerHanlder) => {
  switch (column.itemName) {
    case 'alertLevels':
      return <AlertLevels data={record.alertLevels} />;
    case 'id':
      return (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'wrap'
          }}>
          <p
            className={style.tableLink}
            style={{ overflowWrap: 'anywhere', textAlign: 'center' }}>
            {record[column.itemName]}
          </p>
          {record.productionStatus && (
            <Popover
              placement="top"
              title={'Currently in production'}
              trigger="hover"
              overlayClassName="inProduction-Popover">
              <button style={{ cursor: 'default' }}>
                <InProductionIcon color={'#21B4BD'} />
              </button>
            </Popover>
          )}
        </div>
      );
    case 'executionStatus':
      return (
        <div
          className={style.status}
          style={{
            color:
              record[column.itemName]?.toLowerCase() === 'in production'
                ? '#e29840'
                : record[column.itemName]?.toLowerCase() === 'running'
                ? '#48c93d'
                : record[column.itemName]?.toLowerCase() === 'completed'
                ? '#71C969'
                : record[column.itemName]?.toLowerCase() === 'failed'
                ? '#df6057'
                : '#748aa1'
          }}>
          {record[column.itemName] ? record[column.itemName] : '--'}
        </div>
      );
    case 'activityLog':
      return (
        <div
          className={style.flexCenter}
          onClick={() => hanldeDrawerHanlder(record)}
          id="historyBtn">
          <FontAwesomeIcon
            icon={faHistory}
            style={{ fontSize: '16px', cursor: 'pointer' }}
            color="#748AA1"
          />
        </div>
      );
    case 'actions':
      return (
        <button
          disabled={record?.ticketStatus?.toLowerCase() === 'pending approval'}
          style={{
            cursor:
              record?.ticketStatus?.toLowerCase() === 'pending approval'
                ? 'not-allowed'
                : 'pointer'
          }}
          onClick={() => {
            apiActions.postRunRunInstance({
              id: record.id,
              name: record.name
            });
          }}>
          <FontAwesomeIcon
            icon={faPlay}
            style={{
              fontSize: '16px',
              color:
                record?.ticketStatus?.toLowerCase() === 'pending approval'
                  ? '#c1bfbf'
                  : '#748AA1'
            }}
          />
        </button>
      );
    case 'createdAt':
      return <>{convertISOToDateTimeFormat(record.createdAt)}</>;
    case 'updatedAt':
      return <>{convertISOToDateTimeFormat(record.updatedAt)}</>;
    default:
      return null;
  }
};

export const parseColumnsForRunInstanceSummaryListing = (
  settings,
  apiActions,
  hanldeDrawerHanlder
) => {
  let columns = null;

  if (settings) {
    const sortedSettings = orderBy(settings, ['columnIndex'], ['asc'])
      .filter((column) => column.columnVisibility)
      .filter((column) => column.columnDetail[0]?.itemName !== 'radioAction');

    columns = sortedSettings.map((setting) => {
      return {
        title: (
          <div className={style.tableHeader}>
            {orderBy(setting.columnDetail, ['itemIndex'], ['asc'])
              .filter((column) => column.visibility)
              .map((column, idx) => (
                <p key={idx} className={style.strong}>
                  {column.itemLabel}
                </p>
              ))}
          </div>
        ),
        width: orderBy(setting.columnDetail, ['itemIndex'], ['asc'])
          .filter((column) => column.visibility)
          .map((column, idx) =>
            column.itemName === 'radioAction'
              ? '36px'
              : column.itemName === 'createdAt' ||
                column.itemName === 'updatedAt'
              ? '135px'
              : column.itemName === 'status'
              ? '100px'
              : column.itemName === 'alertLevels'
              ? '235px'
              : column.itemName === 'alertsCount'
              ? '85px'
              : column.itemName === 'activityLog'
              ? '78px'
              : column.itemName === 'actions'
              ? '140px'
              : null
          ),
        align: orderBy(setting.columnDetail, ['itemIndex'], ['asc'])
          .filter((column) => column.visibility)
          .map((column, idx) =>
            column.itemName === 'activityLog' ? 'center' : 'left'
          ),
        render: (text, record) => (
          <div className={style.tableContent}>
            {orderBy(setting.columnDetail, ['itemIndex'], ['asc'])
              .filter((column) => column.visibility)
              .map((column, idx) => {
                if (getColumnRender(column, record) !== null)
                  return getColumnRender(
                    column,
                    record,
                    apiActions,
                    hanldeDrawerHanlder
                  );
                else if (setting.columnDetail.length >= 2)
                  return (
                    <p key={record.alertId + idx} className={style.mutliRecord}>
                      {record[column.itemName] ? record[column.itemName] : '--'}
                    </p>
                  );
                else
                  return (
                    <p
                      key={record.alertId + idx}
                      className={style.singleRecord}>
                      {record[column.itemName]
                        ? Number.isFinite(record[column.itemName])
                          ? record[column.itemName]?.toLocaleString('en-US')
                          : record[column.itemName]
                        : '--'}
                    </p>
                  );
              })}
          </div>
        )
      };
    });
  }
  return columns;
};

const getColumnRenderForActivityLog = (column, record) => {
  if (column.itemName === 'status') {
    return (
      <div className={style.tagContainer}>
        <div className={style['tag__' + record[column.itemName].toLowerCase()]}>
          {record[column.itemName]}
        </div>
      </div>
    );
  } else return null;
};

export const parseColumnsForRunInstanceActivityLog = (settings) => {
  let columns = null;
  if (settings) {
    const sortedSettings = orderBy(settings, ['columnIndex'], ['asc']).filter(
      (column) => column.columnVisibility
    );

    columns = sortedSettings.map((setting) => {
      return {
        title: (
          <div className={style.tableHeader}>
            {orderBy(setting.columnDetail, ['itemIndex'], ['asc'])
              .filter((column) => column.visibility)
              .map((column, idx) => (
                <p key={idx} className={style.strong}>
                  {column.itemLabel}
                </p>
              ))}
          </div>
        ),
        render: (text, record) => (
          <div className={style.tableContent}>
            {orderBy(setting.columnDetail, ['itemIndex'], ['asc'])
              .filter((column) => column.visibility)
              .map((column, idx) => {
                if (getColumnRenderForActivityLog(column, record) !== null)
                  return getColumnRenderForActivityLog(column, record);
                else if (column?.itemName == 'executionDate') {
                  return (
                    <p
                      key={record.alertId + idx}
                      className={style.singleRecord}>
                      {record[column.itemName]
                        ? convertISOToDateFormat(record?.[column?.itemName])
                        : '--'}
                    </p>
                  );
                } else if (column?.itemName == 'dateRange') {
                  return (
                    <p
                      key={record.alertId + idx}
                      className={style.singleRecord}>
                      <Space>
                        <span>
                          {record['startDate']
                            ? convertISOToDateFormat(record?.['startDate'])
                            : '--'}
                        </span>
                        -
                        <span>
                          {record['endDate']
                            ? convertISOToDateFormat(record?.['endDate'])
                            : '--'}
                        </span>
                      </Space>
                    </p>
                  );
                } else
                  return (
                    <p
                      key={record.alertId + idx}
                      className={style.singleRecord}>
                      {record[column.itemName] ? record[column.itemName] : '--'}
                    </p>
                  );
              })}
          </div>
        )
      };
    });
  }
  return columns;
};
